jQuery(document).ready(function($) {

	$('.bm-agenda__item').each(function() {
		var $tabs = $(this).find('.bm-agenda-tabs__tab');

		// Show the first tab content and mark its corresponding tab as active on load
		var $firstTab = $tabs.first(); // Select the first tab
		var firstTarget = $firstTab.data('target');
		showTabContent(firstTarget, $(this)); // Show corresponding tab content

		// When a tab is clicked
		$tabs.click(function() {
			var target = $(this).data('target');
			showTabContent(target, $(this).closest('.bm-agenda__item'));
		});

		// Function to show/hide tab contents based on the target and activate the tab
		function showTabContent(target, $agendaItem) {
			$agendaItem.find('.bm-agenda-content__tab').each(function() {
				var selfTarget = $(this).data('self');
				if (selfTarget === target || !selfTarget) {
					$(this).show();
				} else {
					$(this).hide();
				}
			});

			// Update border color and active class for tabs
			$tabs.removeClass('active'); // Remove active class from all tabs
			var $targetTab = $tabs.filter('[data-target="' + target + '"]');
			$targetTab.addClass('active'); // Add active class to the target tab

			// Update border color based on the displayed tab content
			var $targetTabContent = $agendaItem.find('.bm-agenda-content__tab[data-self="' + target + '"]');
			var borderColor = $targetTabContent.data('colour');
			$agendaItem.find('.bm-agenda-tab-content').css('border-color', borderColor || '');

			// Check the height of the tab content
			var tabContentHeight = $targetTabContent.outerHeight();
			if (tabContentHeight > 250 && !$targetTabContent.hasClass('expanded')) {
				// Add "Read More" toggle button if height exceeds 250px
				if (!$targetTabContent.next('.read-more-btn').length) {
					$targetTabContent.append('<button class="read-more-btn">Read More</button>');
				}

				// Add collapsed class to the tab content if height exceeds 250
				$targetTabContent.addClass('collapsed');
			} else {
				// Remove "Read More" toggle button if height is less than or equal to 250
				$targetTabContent.next('.read-more-btn').remove();
			}
		}
	});

	// Event delegation for "Read More" button click
	$(document).on('click', '.read-more-btn', function() {
		var $tabContent = $(this).closest('.bm-agenda-content__tab');
		$tabContent.toggleClass('collapsed');
		$tabContent.addClass('expanded');
		$(this).remove();
	});

	$('.bm-agenda-wrapper-dates__date').each(function() {
		var $target = $('.bm-agenda[data-agenda-id="' +  $(this).data('target')  + '"]');

		// Hide this
		$target.hide();

		$(this).click(function() {
			showDate($target, $(this));
		});

		function showDate(target, button) {
			$('.bm-agenda').hide();
			target.show();

			$('.bm-agenda-wrapper-dates__date').removeClass('active');
			button.addClass('active');
		}

		// Trigger click on the first date button
		if ($(this).is(':first-child')) {
			$(this).click();
		}
	});

});
